import React, { useContext } from 'react'
import styles from "./mainInfo.module.css"
import { store } from '../state/state';
import { translate } from '../state/translate';

export default function MainInfo() {
  const { selectedLang } = useContext(store);
  return (
    <div className={styles['information']}>
        <p>
            {translate[selectedLang].mainInfo}
        </p>
    </div>
  )
}
